module.exports = __webpack_public_path__ + "img/checked.b0493bd1.svg";